module.exports = __webpack_public_path__ + "assets/img/2-1.a326ecec.svg";